import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';

import { ErrorBoundary } from '@/components/ErrorBoundary';

/** Keep unexpected rendering or query failures inside the affected policy section. */
export const PolicySectionBoundary = ({ name, children }: PropsWithChildren<{ name: string }>) => {
    // The scroll spy rewrites the hash, so reset only on pathname changes to avoid re-throwing on scroll.
    const { pathname } = useLocation();
    return (
        <ErrorBoundary
            resetKey={pathname}
            fallback={
                <p role="alert" className="text-cocoa-600 rounded-[10px] border border-stone-200 p-6 text-sm">
                    {name} is currently unavailable. Reload the page to try again.
                </p>
            }
        >
            {children}
        </ErrorBoundary>
    );
};
